import classname from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({ children, visible, addClass, variant }) => {

	const modalClass = classname(
		addClass,
		{
			modal: true
		}
	);

	// Variant sizing (matches admin-ui's components/Modal). Additive: with no
	// variant, no wrapper class is applied so existing pitstop-ui modals are
	// unchanged; the ported Account Settings modals pass variant='medium'/'small'.
	const modalWrapperClass = classname({
		'modal_wrapper--small': variant === 'small',
		'modal_wrapper--medium': variant === 'medium',
		'modal_wrapper--large': variant === 'large'
	});

	return visible ?
		ReactDOM.createPortal(
			<div className={modalClass}>
				<div className={`modal__content ${modalWrapperClass}`}>
					{children}
				</div>
			</div>
			, document.body
		)
		: null;
}

Modal.propTypes = {
	visible: PropTypes.bool,
	addClass: PropTypes.string,
	variant: PropTypes.oneOf(['small', 'medium', 'large']),
	children: PropTypes.node
}

export default Modal;
